import { QRCodeSVG } from "qrcode.react";
import React from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import logo from '../../../assets/img/lubeco_smart_without_R-removebg.png'

function QRView({ machine, size = 128 }) {
  return (
    <Card className="p-2 shadow-sm border-2">
      <CardBody className="d-flex flex-column align-items-center justify-content-center">
        <CardTitle
          tag="h6"
          className="font-weight-bold text-primary text-truncate my-0"
        >
          {machine.name}
        </CardTitle>
        <hr className="w-100 my-2" />
        <div className="p-2 bg-white rounded border d-inline-block">
          <QRCodeSVG
            value={machine.id}
            size={size}
            level="H"
            bgColor={"#FFFFFF"}
            fgColor={"#000000"}
            imageSettings={{
              src: logo,
              excavate: true,
              height: 50,
              width: 80
            }}
          />
        </div>
        <hr className="w-100 my-2" />
        <div className="d-flex flex-column align-items-center">
          <Row className="text-md d-flex font-weight-bold" style={{ gap: 3 }}>
            <span>ID:</span>
            <label>{machine.serial_number}</label>
          </Row>
          <Row className="text-md d-flex font-weight-bold" style={{ gap: 3 }}>
            <span>Tank:</span>
            <label>{machine.tankSize}</label>
          </Row>
        </div>
      </CardBody>
    </Card>
  );
}

export default QRView;
